import React from 'react';
import validator from 'validator';
import _ from './i18n';

const validation = {
    required(value, props, components) {
        if (value !== undefined) {
            if (!props['data-edited']) {
                if (props.isCheckable) {
                    if (components[props.name].reduce((a, b) => {
                        return a || b.checked;
                    }, false) === false) {
                        return <span className="form-error is-visible text-danger">{_('Pole wymagane')}</span>;
                    }
                } else {
                    if (!value.toString().trim().length) {
                        // We can return string or jsx as the 'error' prop for the validated Component
                        return <span className="form-error is-visible text-danger">{_('Pole wymagane')}</span>;
                    }
                }
            }
        }
    },

    email(value) {
        if (!validator.isEmail(value)) {
            return <span className="form-error is-visible text-danger">{value} - {_('to nie jest prawidłowy adres email')}.</span>
        }
    },

    lt(value, props) {
        // get the maxLength from component's props
        if (value !== undefined && value.toString().trim().length > props.maxLength) {
            // Return jsx
            return <span className="form-error is-visible text-danger">{_('Pole przekracza maksymalną długość')} {props.maxLength} {_('znaków')}.</span>
        }
    },

    gt(value, props) {
        // get the maxLength from component's props
        if (value !== undefined && value.toString().trim().length !== 0 && value.toString().trim().length < props.minLength) {
            // Return jsx
            return <span className="form-error is-visible text-danger">{_('Pole musi mieć długość co najmniej')} {props.minLength} {_('znaków')}.</span>
        }
    },

    // dokładnie tyle znaków
    textLengthEq(value, props) {
        // get the maxLength from component's props
        if (value !== undefined && value.toString().trim().length !== 0 && value.toString().trim().length !== parseInt(props.textLength, 10)) {
            // Return jsx
            return <span className="form-error is-visible text-danger">{_('Pole musi mieć długość')} {props.textLength} {_('znaków')}.</span>
        }
    },

    isEqual(value, props, components) {
        const bothUsed = components.haslo[0].isUsed && components.potwierdz_haslo[0].isUsed;
        const bothChanged = components.haslo[0].isChanged && components.potwierdz_haslo[0].isChanged;

        if (bothChanged && bothUsed && components.haslo[0].value !== components.potwierdz_haslo[0].value) {
            return <span className="form-error is-visible text-danger">{_('Hasła się nie zgadzają')}.</span>;
        }
    },

    isDate(value) {
        if (!validator.isISO8601(value)) {
            return <span className="form-error is-visible text-danger">{_('Wpisz datę w formacie RRRR-MM-DD')}.</span>
        }
    }
}

export { validation };